import React, { PureComponent } from 'react';
import { List, Map } from 'immutable';
import { CSSTransition } from 'react-transition-group';
import PropTypes from 'prop-types';
import { clearAllBodyScrollLocks, enableBodyScroll } from 'body-scroll-lock';
import styles from 'modules/Notifications/components/NotificationsSidebar/NotificationsSidebar.module.scss';
import NotificationsList from 'modules/Notifications/components/NotificationsList';
import NotificationHeader from 'modules/Notifications/components/NotificationHeader';
import Loading from 'components/Loading';
import Modal from 'components/Modal';
import { getLink } from 'modules/Notifications/utils';

class NotificationsSidebar extends PureComponent {
  componentDidMount() {
    const { initializeNotifications } = this.props;
    initializeNotifications();
  }

  componentWillUnmount() {
    const { stopNotificationsPolling } = this.props;
    clearAllBodyScrollLocks();
    stopNotificationsPolling();
  }

  onItemClick = (item) => {
    const { siteMap, goToLink, showNotificationModal } = this.props;

    if (item.get('link')) {
      goToLink(
        getLink(siteMap, item.get('link'), {
          cardId: item.get('cardId'),
          notificationId: item.get('notificationId'),
          eventTypeId: item.get('eventTypeId'),
        }),
      );
      this.onClose();
    }

    if (item.get('isTextMessage')) {
      showNotificationModal({
        id: item.get('id'),
        title: item.get('subject'),
        content: item.get('text'),
      });
      this.onClose();
    }
  };

  onClose = () => {
    const { hideSidebar } = this.props;
    hideSidebar();
    enableBodyScroll();
  };

  onRead = (id, notificationId, eventTypeId) => {
    const { readNotification } = this.props;
    readNotification({ id, notificationId, eventTypeId });
  };

  onRemove = (id, notificationId, eventTypeId) => {
    const { removeNotification } = this.props;
    removeNotification({ id, notificationId, eventTypeId });
  };

  onReadAll = () => {
    const { readAllNotifications } = this.props;
    readAllNotifications();
  };

  onRemoveAll = () => {
    const { removeAllNotifications } = this.props;
    removeAllNotifications();
  };

  fetchMore = () => {
    const { getMoreNotifications, notifications } = this.props;
    getMoreNotifications({ offset: notifications.size });
  };

  renderModal() {
    const { modalIsVisible, modalData, closeNotificationModal } = this.props;

    return (
      <Modal showModal={modalIsVisible} onClose={closeNotificationModal}>
        <h2>{modalData.get('title')}</h2>
        {/* eslint-disable-next-line react/no-danger */}
        <div dangerouslySetInnerHTML={{ __html: modalData.get('content') }} />
      </Modal>
    );
  }

  render() {
    const {
      notifications,
      sidebarIsVisible,
      isLoading,
      newNotifications,
      fetchingMore,
      hasNextPage,
    } = this.props;

    return (
      <>
        <CSSTransition
          in={sidebarIsVisible}
          timeout={500}
          classNames={styles.animation}
          unmountOnExit
        >
          <div className={styles.sideBarContainer}>
            <div className={styles.sideBarOverlay} onClick={this.onClose} />
            <div className={styles.sideBar}>
              <NotificationHeader notificationsCount={newNotifications} onClose={this.onClose} />
              {!isLoading && (
                <NotificationsList
                  notifications={notifications}
                  onRead={this.onRead}
                  onRemove={this.onRemove}
                  onRemoveAll={this.onRemoveAll}
                  onReadAll={this.onReadAll}
                  hasMore={hasNextPage}
                  fetching={fetchingMore}
                  fetchMore={this.fetchMore}
                  onItemClick={this.onItemClick}
                />
              )}
              {!isLoading && !notifications.size && (
                <div className={styles.empty}>Нет уведомлений</div>
              )}
              {isLoading && (
                <div className={styles.loadingContainer}>
                  <Loading />
                </div>
              )}
            </div>
          </div>
        </CSSTransition>
        {this.renderModal()}
      </>
    );
  }
}

NotificationsSidebar.propTypes = {
  notifications: PropTypes.instanceOf(List),
  newNotifications: PropTypes.number,
  isLoading: PropTypes.bool,
  fetchingMore: PropTypes.bool,
  error: PropTypes.instanceOf(Map),
  modalData: PropTypes.instanceOf(Map),
  sidebarIsVisible: PropTypes.bool,
  showSidebar: PropTypes.func.isRequired,
  hideSidebar: PropTypes.func.isRequired,
  getNotifications: PropTypes.func.isRequired,
  stopNotificationsPolling: PropTypes.func.isRequired,
  initializeNotifications: PropTypes.func.isRequired,
  readNotification: PropTypes.func.isRequired,
  removeNotification: PropTypes.func.isRequired,
  readAllNotifications: PropTypes.func.isRequired,
  removeAllNotifications: PropTypes.func.isRequired,
  getMoreNotifications: PropTypes.func.isRequired,
  hasNextPage: PropTypes.bool,
  modalIsVisible: PropTypes.bool,
  closeNotificationModal: PropTypes.func.isRequired,
  siteMap: PropTypes.array.isRequired,
  goToLink: PropTypes.func.isRequired,
  showNotificationModal: PropTypes.func.isRequired,
};

export default NotificationsSidebar;
